import { useMemo } from 'react'

export const profile = (state, props) => {
  return useMemo(() => {
    return state.selected !== null ? props.profiles[state.selected] : null
  }, [props.profiles, state.selected])
}
